import RESOURCE_TYPES from "../types/resourceTypes";

const initialState = {
  loading: false,
  submitting: false,
  resources: [],
  currentResource: null,
  songs: [],
  currentPage: 1,
  isLastPage: true,
  error: null,
};

export default function resourceReducer(state = initialState, action) {
  switch (action.type) {
    case RESOURCE_TYPES.FETCH_RESOURCE_LIST_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case RESOURCE_TYPES.FETCH_RESOURCE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: action.payload.data,
      };

    case RESOURCE_TYPES.FETCH_RESOURCE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case RESOURCE_TYPES.FETCH_RESOURCE_DETAILS_BEGIN:
      return {
        ...state,
        currentResource: null,
        loading: true,
        error: null,
      };

    case RESOURCE_TYPES.FETCH_RESOURCE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentResource: action.payload.data,
      };

    case RESOURCE_TYPES.FETCH_RESOURCE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case RESOURCE_TYPES.FETCH_SONGS_BEGIN:
      return {
        ...state,
        loading: true,
        currentPage: action.payload.page,
        error: null,
      };

    case RESOURCE_TYPES.FETCH_SONGS_SUCCESS:
      return {
        ...state,
        loading: false,
        songs: action.payload.data.songs,
        isLastPage: action.payload.data.isLastPage,
      };

    case RESOURCE_TYPES.FETCH_SONGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
